module.exports = __webpack_public_path__ + "e68c6154b835c0afdd2ad2aaf1801eda.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_l_40.mp3
// module id = 453
// module chunks = 0